// components/Footer.js - WITHOUT SOCIAL ICONS
import { FaFacebook } from 'react-icons/fa';
import React from 'react';
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope,
  FaSolarPanel,
  FaWater,
  FaBolt,
  FaPlug,
  FaChartBar,
  FaClipboardCheck,
  FaCertificate
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="footer-overlay"></div>
      </div>
      
      <div className="container">
        <div className="footer-content">
          {/* Logo and Description Section */}
          <div className="footer-logo-section">
            <div className="footer-logo">
              <a href="#home">
                <img 
                  src="/logowhite.png" 
                  alt="Sunsight Energy Logo" 
                />
              </a>
            </div>
            <p className="footer-description">
              Leading provider of solar energy solutions in Malawi and beyond since 2018. 
              Registered with Malawi Energy Regulatory Authority (MERA) and trusted by 
              government and international organizations.
            </p>
         <div className="footer-social">
  <a 
    href="https://www.facebook.com/sunsightenergymw" 
    target="_blank" 
    rel="noopener noreferrer"
    className="social-link"
  >
    <FaFacebook style={{ marginRight: '8px' }} />
    Follow us
  </a>
</div>
          </div>
          
          {/* Quick Links Section */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Our Services</a></li>
              <li><a href="#team">Our Team</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
         {/* Footer component - "Our Services" section} */}
<div className="footer-section">
  <h4>Our Services</h4>
  <ul className="footer-services">
    <li>
      <FaSolarPanel />
      <span>Solar Mini-Grid Systems</span>
    </li>
    <li>
      <FaWater />
      <span>Solar Water Pumping</span>
    </li>
    <li>
      <FaBolt />
      <span>On-Grid Solar Systems</span>
    </li>
    <li>
      <FaPlug />
      <span>Off-Grid Solar Systems</span>
    </li>
    <li>
      <FaChartBar />
      <span>Energy Auditing</span>
    </li>
    <li>
      <FaClipboardCheck />
      <span>Consultancy</span>
    </li>
  </ul>
</div> 
          {/* Contact Info Section */}
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-text">
                  <p>Area 18 Creswell House</p>
                  <p>Along M1 Road,</p>
                  <p>P.O. BOX 40570, Lilongwe</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <FaPhoneAlt />
                </div>
                <div className="contact-text">
                  <p>+265888615918</p>
                  <p>+265993614876</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-text">
                  <p>sales@sunsightenergyltd.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="certifications">
            <span className="cert-badge">
              <FaCertificate style={{marginRight: '8px', fontSize: '14px'}} />
              MERA Certified
            </span>
            <span className="cert-badge">
              <FaCertificate style={{marginRight: '8px', fontSize: '14px'}} />
              PPDA Registered
            </span>
            <span className="cert-badge">
              <FaCertificate style={{marginRight: '8px', fontSize: '14px'}} />
              NCIC Certified
            </span>
            <span className="cert-badge">
              <FaCertificate style={{marginRight: '8px', fontSize: '14px'}} />
              MRA Registered
            </span>
          </div>
          <p>&copy; {new Date().getFullYear()} Sunsight Energy Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;